var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damages-types view" }, [
    !_vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-category-specific", {
              attrs: {
                titleNavbar: _vm.$t("damagesTypes.titleNavbar"),
                qaName: "go-to-addDamages-btn",
                handleClickBackArrow: _vm.handleGoToDamagesView,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: {
                numberOfStep: 2,
                textOfStep: _vm.$t("Déclaration des dommages"),
                qaName: "go-to-addDamages-btn",
                handleClickBack: _vm.handleGoToDamagesView,
                arrowIsAllow: true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "view_content" }, [
      _c(
        "ul",
        {
          staticClass: "view-list has-two-cols",
          attrs: { "qa-list-damage-types": "" },
        },
        _vm._l(_vm.dataDamageTypes.options, function (damageType) {
          return _c(
            "li",
            [
              _c("ma-damage-type-btn", {
                attrs: {
                  iconName: damageType.self_care_icon,
                  buttonTitle: damageType.literal,
                  valueInput: damageType.key,
                  type: "input",
                },
                on: {
                  "button:clicked": function ($event) {
                    return _vm.handleClickDamageType(
                      damageType.key,
                      damageType.literal
                    )
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }